import './Tags.css';

export default function Tags() {
  return (
    <div className="container text-center py-4 col-lg-8 mb-4">
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        System Analyst
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Software Engineer
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.credly.com/badges/26f505fd-b782-4064-b24f-3e0724ed54f1"
          target="_blank"
          rel="noopener noreferrer"
        >
          AWS Certified Solutions Architect - Associate
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.credly.com/badges/713879ca-309f-4385-b7bf-fdb5415e3710"
          target="_blank"
          rel="noopener noreferrer"
        >
          AWS Certified Cloud Practitioner
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.credly.com/badges/92ee0655-5950-4a4a-9382-d1f07da154c3/public_url"
          target="_blank"
          rel="noopener noreferrer"
        >
          CompTIA Security+
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.credly.com/badges/5429c58c-e075-4b86-acbb-0747f42b96a4/public_url"
          target="_blank"
          rel="noopener noreferrer"
        >
          Building AI Agents with MongoDB
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.credly.com/badges/8143605d-ba33-486f-b841-7d16933fdce2/public_url"
          target="_blank"
          rel="noopener noreferrer"
        >
          Building AI-Powered Search with MongoDB Vector Search
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.credly.com/badges/84dcb243-2583-43ff-bde5-fd49d198c011/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Building RAG Apps Using MongoDB
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://badgr.com/public/assertions/gIqDvt7LQ5Oq6CqWwsBByA"
          target="_blank"
          rel="noopener noreferrer"
        >
          Postman API Fundamentals Student Expert
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.linkedin.com/posts/qingquan-li_gamejam-gamedevelopment-brooklyncollege-activity-7263958474194051073-1xai/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Computer Science Club President
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://devpost.com/Qingquan-Li"
          target="_blank"
          rel="noopener noreferrer"
        >
          3x Hackathon Winner
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://openlab.bmcc.cuny.edu/research-and-scholarship/2023/04/27/design-a-crowdsourced-app-for-enhancing-storefront-accessibility-for-visually-impaired-individuals/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Research Assistant
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://www.youtube.com/watch?v=ClTm-6G-sXs&ab_channel=QingquanLi"
          target="_blank"
          rel="noopener noreferrer"
        >
          Startup Founder
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://github.com/qingquan-li"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub Starstruck
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Fundraising Volunteer
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Table Tennis Champion
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        <a
          href="https://github.com/qingquan-li/blog"
          target="_blank"
          rel="noopener noreferrer"
        >
          Blogger
        </a>
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Python
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Java
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        JavaScript
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        C++
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Django
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Flask
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Spring Boot
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        React
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        PostgreSQL
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Oracle DB
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        MongoDB
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Linux
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Docker
      </span>
      <span className="badge rounded-pill text-bg-light p-2 m-1">
        Kubernetes
      </span>
    </div>
  );
}